
const LifSale = {
  OFFER_1_FREE: '1free',
  FWP_SALE: 'fwp_sale',
  OFFER_FIXED_PRICE: 'fixed_price',
  DYNAMIC_SALE: 'dynamic_sale',
  CUSTOM_BUNDLE: 'custom_bundle',
  BLACK_FRIDAY: 'black_friday',
  INCREMENTAL_SALE: 'incremental_sale'
};

Object.freeze(LifSale);

document.addEventListener('alpine:init', () => {
  /* 
   * Calculate applicable sale price for product
   */
  Alpine.data('productSale', () => ({
    // productTags: [],

    applicableSale: null, // LifSale
    offer1Free: {
      saleName: 'Offer 1 Free',
      salePriceText: 'FREE',
      salePriceValue: 0,
      offerSettings: null,
    },
    offerFixedPrice: {
      saleName: '$5 Sweatshirt',
      salePriceText: '$5',
      salePriceValue: 5,
    },
    dynamicSale: {
      saleName: null,
      salePriceText: null,
      salePriceValue: null,
    },
    memberDiscount: {
      percentage: 0,
      price: null,
    },
    customBundle: {
      saleName: null,
      salePriceText: null,
      salePriceValue: null,
    },
    blackFriday: {
      saleName: null,
      salePriceText: null,
      salePriceValue: null,
      offerIndex: 0,
    },
    incrementalSale: {
      saleName: null,
      salePriceText: null,
      salePriceValue: null,
      offerCode: null,
    },

    get offerActivationCompleted() {
      Alpine.store('customBundle').activationCompleted || 
      Alpine.store('dynamicSale').activationCompleted || 
      Alpine.store('offer1Free').activationCompleted || 
      Alpine.store('offerFixedPrice').activationCompleted || 
      Alpine.store('fwpOffer').activationCompleted ||
      Alpine.store('blackFridaySale').activationCompleted || 
      Alpine.store('incrementalSale').activationCompleted ||
      Alpine.store('buyMoreSaveMoreOffer').isActive
    },

    init() {
      this.initSale();
      this.$watch('product', (has) => {
        this.initSale();
      });

      // Set fetch from cookie after final offer activated
      this.$watch('offerActivationCompleted', (has) => {
        this.initSale();
      });
    },

    // this trigger on page load
    initSale() {
      if (!this.product) {
        return;
      }

      // this.productTags = this.product.tags; // .split(',').map((t) => t.trim());

      // Get sale details from store if active
      const { saleDetails: dynamicSale } = Alpine.store('dynamicSale');
      if (dynamicSale) {

        // find applicable dynamic sale tag for product
        const saleTagPart = `_${dynamicSale.saleName}::`.toLowerCase();
        const saleTag = this.product.tags.find((tag) => tag.toLowerCase().startsWith(saleTagPart));

        if (saleTag) {
          // fetch price from sale tag 
          const salePrice = saleTag.toLowerCase().replace(saleTagPart, '');
          const localCurrencySalePrice = Alpine.store('currency').convertLocal(Number(salePrice));

          const productPrice = Number(this.product.variants[0].price) / 100;

          if (productPrice > localCurrencySalePrice) {
            this.dynamicSale = {
              salePriceValue: localCurrencySalePrice,
              salePriceText: Alpine.store('currency').formatMoney(localCurrencySalePrice),
              // Save applied sale name for reference
              saleTag: dynamicSale.saleName,
              saleName: dynamicSale.saleName,
              matchedProductTag: `_${dynamicSale.saleName}::${localCurrencySalePrice.toFixed(2)}`,
            }

            this.applicableSale = LifSale.DYNAMIC_SALE;
          } else {
            this.dynamicSale = null;
            this.applicableSale = null;  
          }
        } else {
          this.dynamicSale = null;
          this.applicableSale = null;
        }
      }

      this.memberDiscount = {
        percentage: this.memberDiscountPercentage(),
        price: this.calculateMemberDiscountedPrice(),
      }

      // console.log('this.memberDiscount: ');
      // console.log(this.memberDiscount);

      this.setOffer1Free();
      this.$watch('cartHasFreeShirt', (has) => {
        this.setOffer1Free();
      });

      this.setOfferFixedPrice();
      this.$watch('cartHasFixedPriceShirt', (has) => {
        this.setOfferFixedPrice();
      });

      this.setBundleSale();
      this.$watch('isBundleCompleted', () => {
        this.setBundleSale();
      });

      this.$watch('includedBundleComponents', () => {
        this.setBundleSale();
      });

      this.setFWPSale();
      this.setBlackFridaySale();
      this.setIncrementalSale();
      this.$watch('incrementalSaleProcessSteps', () => {
        this.setIncrementalSale();
      });

      if (Alpine.store('buyMoreSaveMoreOffer').isActive) {
        this.resetOffer();
      }
    },
    setBundleSale() {

      if (Alpine.store('cart').hasAbsoluteFreeProduct) {
        return;
      }

      const assignSale = (isCompleted, settings, saleDetails, includedBundleComponents) => {
        if (isCompleted) {
          const productCustomSale = settings.productPrices.find((p) => 
            p.product_types.includes(this.product.product_type)
          );

          if (productCustomSale) {
            this.applicableSale = LifSale.CUSTOM_BUNDLE;

            const salePriceValue = Number(productCustomSale.price).toFixed(2);
            this.customBundle = {
              saleName: saleDetails.saleName,
              saleKey: saleDetails.saleKey,
              salePriceValue,
              salePriceText: Alpine.store('currency').formatMoney(salePriceValue)
            }

            return true;
          }
        } else {
          // Important: Check if bundle component product type is match and same index in not added yet
          const componentIndex = settings.bundleComponents.findIndex((c, i) => {
            return c.product_types.includes(this.product.product_type) && !includedBundleComponents.includes(i)
          });

          if (componentIndex != -1) {
            this.customBundle = {
              saleName: saleDetails.saleName,
              saleKey: saleDetails.saleKey,
              componentIndex
            }

            // On PDP page, set saleKey based on offer applied
            if (!Alpine.store('customBundle').saleKey) {
              Alpine.store('customBundle').saleKey = saleDetails.saleKey;
            }

            return true;
          }
        }

        return false;
      }
      
      // Check if bundle sale is active
      let { 
        isCompleted, 
        saleKey,
        thisSettings: settings, 
        thisSaleDetails: saleDetails, 
        saleHandles, 
        allIncludedBundleComponents, 
        includedBundleComponents 
      } = Alpine.store('customBundle');

      // Let's figure out that product is eligible for which bundle sale (If multiple sale is active)
      if (settings) { // This is on sale collection page
        assignSale(isCompleted[saleKey], settings, saleDetails, includedBundleComponents);
      } else { // This is outside of sale collection page
        // iterate through all bundle sales and apply applicable sale for product
        for (const handle of saleHandles) {
          settings = Alpine.store('customBundle').settings[handle];
          saleDetails = Alpine.store('customBundle').saleDetails[handle];

          if (!saleDetails) {
            continue;
          }

          const assigned = assignSale(isCompleted[handle], settings, saleDetails, allIncludedBundleComponents[handle]);
          if (assigned) {
            break;
          }
        }
      }
    },
    setIncrementalSale() {
      // Check if bundle sale is active
      const { isCompleted, settings, saleDetails, bundleItems, activePrice } = Alpine.store('incrementalSale');

      if (!saleDetails) {
        return;
      }

      this.applicableSale = LifSale.INCREMENTAL_SALE;

      if (isCompleted) {
        const productCustomSale = settings.productPrices.find((p) => 
          p.product_types.includes(this.product.product_type)
        );

        if (productCustomSale) {
          const salePriceValue = Number(productCustomSale.price).toFixed(2);
          this.incrementalSale = {
            saleName: saleDetails.saleName,
            salePriceValue,
            salePriceText: Alpine.store('currency').formatMoney(salePriceValue),
            offerCode: saleDetails.offerCode,
          }
        } else {
          this.applicableSale = null;
        }
      } else {
        if (saleDetails.offerCode == 'v2') {
          const { priceTiers, activeIndex } = Alpine.store('incrementalSaleV2');
          for (const priceTier of priceTiers) {

            if (priceTier.product_types.includes(this.product.product_type)) {
              const tierIndex = activeIndex;

              const saleActivePrice = parseFloat(priceTier.prices[tierIndex]).toFixed(2);
              this.incrementalSale = {
                saleName: saleDetails.saleName,
                salePriceValue: saleActivePrice,
                salePriceText: Alpine.store('currency').formatMoney(saleActivePrice),
                offerCode: saleDetails.offerCode,
              }
            }
          }

          if (!this.incrementalSale.saleName) {
            this.applicableSale = null;
          }
        } else {
          if (settings.applicable_product_types.includes(this.product.product_type)) {
            this.incrementalSale = {
              saleName: saleDetails.saleName,
              salePriceValue: activePrice,
              salePriceText: Alpine.store('currency').formatMoney(activePrice),
              offerCode: saleDetails.offerCode,
            }
          } else {
            this.applicableSale = null;
          }
        }
      }
    },
    get isBundleCompleted() {
      return Alpine.store('customBundle').isCompleted;
    },
    get includedBundleComponents() {
      return Alpine.store('customBundle').includedBundleComponents;
    },
    get incrementalSaleProcessSteps() {
      return Alpine.store('incrementalSale').processSteps;
    },
    get saleData() {
      return { 
        offer1Free: this.offer1Free, 
        dynamicSale: this.dynamicSale, 
        customBundle: this.customBundle,
        memberDiscount: this.memberDiscount,
        blackFriday: this.blackFriday,
        applicableSale: this.applicableSale,
        incrementalSale: this.incrementalSale
      };
    },
    setOffer1Free() {

      // console.log('setOffer1Free...........');
      // Check for 1 free offer
      const { saleDetails, offerCurrentSettings } = Alpine.store('offer1Free');

      if (saleDetails) {

        const applicableProductTypes = window.__LIF__.offer_1_free_settings.applicable_product_types;
        const isApplicableProduct = applicableProductTypes.some((t) => this.product.product_type.includes(t));

        if (isApplicableProduct && !this.cartHasFreeShirt) {
          this.applicableSale = LifSale.OFFER_1_FREE;
          this.offer1Free.offerSettings = offerCurrentSettings;
        } else {
          this.resetOffer();
        }
      }
    },

    setFWPSale() {
      const { saleDetails } = Alpine.store('fwpOffer');

      if (saleDetails) {
        this.applicableSale = LifSale.FWP_SALE;
      }
    },
    
    setOfferFixedPrice() {

      // console.log('setOffer1Free...........');
      // Check for 1 free offer
      const { saleDetails } = Alpine.store('offerFixedPrice');

      if (saleDetails) {

        const isOfferFixedPriceEnabled = window.__LIF__.offer_fixed_price_settings.is_enabled;

        if (!isOfferFixedPriceEnabled) {
          this.resetOffer();
          return;
        }

        const applicableProductTypes = window.__LIF__.offer_fixed_price_settings.applicable_product_types;
        const isApplicableProduct = applicableProductTypes.some((t) => this.product.product_type.includes(t));

        if (isApplicableProduct && !this.cartHasFixedPriceShirt) {
          this.applicableSale = LifSale.OFFER_FIXED_PRICE;
        } else {
          this.resetOffer();
        }
      }
    },
    setBlackFridaySale() {
      const { isActive, activeOffer, saleDetails } = Alpine.store('blackFridaySale');

      // Check if product belongs to offered collection
      if (isActive && activeOffer && this.product.collections.includes(activeOffer.offer_collection)) {
        this.applicableSale = LifSale.BLACK_FRIDAY;

        const offerPrice = Number(activeOffer.offer_discounted_price).toFixed(2);

        this.blackFriday = {
          saleName: saleDetails.saleName,
          salePriceText: offerPrice == 0 ? 'FREE' : Alpine.store('currency').formatMoney(offerPrice),
          salePriceValue: offerPrice,
          offerIndex: activeOffer.index,
        }
      } else {
        // Dynamic sale should also combine with black friday sale so don't reset offer
        // this.resetOffer();
      }
    },
    resetOffer() {
      this.applicableSale = null;
    },
    get cartHasFreeShirt() {
      return Alpine.store('cart').cartItems && Alpine.store('cart').cartItems.find((i) => i.properties.attributes && i.properties.attributes._is_free_shirt);
    },
    get cartHasFixedPriceShirt() {
      return Alpine.store('cart').cartItems && Alpine.store('cart').cartItems.find((i) => i.properties.attributes && i.properties.attributes.__fixed_price_offer);
    },
    get productSalePrice() {

      if (!this.product) { 
        // Product not loaded yet
        return null;
      }

      // debugger;

      const { shouldApplyMembershipDiscount, hasAbsoluteFreeProduct, hasFreeProduct } = Alpine.store('cart');
      const { formatMoney } = Alpine.store('currency');
      
      const {
        thisSettings: bundleSettings,
        isCompleted: isBundleCompleted,
        includedBundleComponents,
        allIncludedBundleComponents,
        saleKey,
        saleHandles
      } = Alpine.store('customBundle');

      if (bundleSettings) {

        
        if (!hasAbsoluteFreeProduct && bundleSettings.isActive) {

          if (!isBundleCompleted[saleKey]) {

            // Important: Check if bundle component product type is match and same index is not added yet
            const componentIndex = bundleSettings.bundleComponents.findIndex((c, i) => {
              return c.product_types.includes(this.product.product_type) && !includedBundleComponents.includes(i)
            });
            
            if (componentIndex != -1) {
              return { type: 'CUSTOM_BUNDLE', price: 'INCLUDED' }
            }
          } else if (this.applicableSale == LifSale.CUSTOM_BUNDLE) {
            return { type: LifSale.CUSTOM_BUNDLE, price: this.customBundle.salePriceText };
          }
        }
      } else {
        if (!hasAbsoluteFreeProduct) {
          for (const handle of saleHandles) {
            const bSettings = Alpine.store('customBundle').settings[handle];
            // saleDetails = Alpine.store('customBundle').saleDetails[handle];

            if (bSettings && bSettings.isActive) {

              if (!isBundleCompleted[handle]) {
    
                // Important: Check if bundle component product type is match and same index in not added yet
                const componentIndex = bSettings.bundleComponents.findIndex((c, i) => {
                  return c.product_types.includes(this.product.product_type) && !allIncludedBundleComponents[handle].includes(i)
                });
                
                if (componentIndex != -1) {
                  return {
                    type: 'CUSTOM_BUNDLE',
                    price: 'INCLUDED'
                  }
                }
              } else if (this.applicableSale == LifSale.CUSTOM_BUNDLE) {
                const productPrice = this.product.variants[0].price / 100;
                if (productPrice > parseFloat(this.customBundle.salePriceValue)) {
                  return { type: LifSale.CUSTOM_BUNDLE, price: this.customBundle.salePriceText };
                }
              }
            }
          }
        }
      }

      const { 
        isActive: buyMoreIsActive, 
        currentDiscountPercentage, 
        pdpSelectedQuantity, 
        isHighestDiscountReached,
        buyMoreBundleItemsSplitedQty
      } = Alpine.store('buyMoreSaveMoreOffer');


      if (buyMoreIsActive && currentDiscountPercentage > 0 && buyMoreBundleItemsSplitedQty.length < 12) {
          
        if (this.product && this.product.variants) {
          const variantPrice = this.product.variants[0].price / 100;

          // Check if PDP product
          const selectedQty = this.isBuyMoreActive ? pdpSelectedQuantity : 1;
          
          // Max offer apply to 12 products
          let offerPrice = variantPrice;
          if (buyMoreBundleItemsSplitedQty.length + selectedQty <= 12) {
            offerPrice = (variantPrice - variantPrice * currentDiscountPercentage / 100) * selectedQty;
          } else {
            offerPrice = (variantPrice - variantPrice * currentDiscountPercentage / 100) * (12 - buyMoreBundleItemsSplitedQty.length); 
            offerPrice += variantPrice * (buyMoreBundleItemsSplitedQty.length + selectedQty - 12)
          }

          // return { type: 'BuyMore', price: '$'+offerPrice.toFixed(2) };
          return { type: 'BuyMore', price: formatMoney(offerPrice) };
        }
      }

      let memberPrice = null;
      if (shouldApplyMembershipDiscount && !Alpine.store('sale').hideMemberWidget) {
        memberPrice = this.memberDiscount.price;
      }

      // No offer can over on top of Absolute Free product
      if (hasAbsoluteFreeProduct || (this.saleName == 'Offer 1 Free' && hasFreeProduct)) {
        if (memberPrice) {
          return { price: 'Member '+ formatMoney(memberPrice), type: 'MEMBER', }
        }
        return null;
      }

      if (this.applicableSale == LifSale.INCREMENTAL_SALE) {
        const variantPrice = this.product.variants[0].price / 100;
        if (variantPrice > this.incrementalSale.salePriceValue) {
          if (Alpine.store('incrementalSale').isCompleted || this.incrementalSale.offerCode == 'v2') {
            return { type: LifSale.INCREMENTAL_SALE, price: this.incrementalSale.salePriceText };
          } else {
            const { activePrice } = Alpine.store('incrementalSale');
            return { type: LifSale.INCREMENTAL_SALE, price: formatMoney(activePrice) };
          }
        }
      }

      if (this.applicableSale == LifSale.OFFER_1_FREE) {
        return { type: '1FREE', price: this.offer1Free.salePriceText };
      }

      if (this.applicableSale == LifSale.OFFER_FIXED_PRICE) {
        return { type: 'FIXED_PRICE', price: this.offerFixedPrice.salePriceText };
      }

      if (this.applicableSale == LifSale.DYNAMIC_SALE) {
          // Dynamic sale
        const dynamicSale = { type: 'DYNAMIC', price: this.dynamicSale.salePriceText };
        if (!memberPrice || parseFloat(memberPrice) > parseFloat(this.dynamicSale.salePriceValue)) {
          return dynamicSale;
        }
      }

      if (this.applicableSale == LifSale.BLACK_FRIDAY && Alpine.store('blackFridaySale').activeOffer) {
        // const { offer_discounted_price } = Alpine.store('blackFridaySale').activeOffer;
        return { type: 'BLACK_FRIDAY', price: this.blackFriday.salePriceText };
      }

      if (memberPrice) {
        return { price: 'Member '+Alpine.store('currency').formatMoney(memberPrice), type: 'MEMBER' }
      }

      // Cheeck if absoulute Free Product
      if (this.product.variants.every(v => v.price == 0)) {
        return { type: 'ABSOLUTE_FREE ', price: 'FREE' };
      }

      return null;
    },
    get finalPrice() {
      if (!this.product) {
        return null;
      }

      if (!this.productSalePrice) {
        return this.product.variants[0].price;
      }

      if (this.productSalePrice.price == 'INCLUDED') {
        return 0;
      }

      const fPrice = parseFloat(this.productSalePrice.price.replace('Member', '').replace('$', '').trim()) * 100;
      return fPrice;
    },
    get memberPrice() {
      if (!this.memberDiscount) {
        return null;
      }
      if (this.memberDiscount.price) {
        // return '$' + this.memberDiscount.price;
        return Alpine.store('currency').formatMoney(this.memberDiscount.price);
      } 

      if (!this.product || !this.product.variants[0]) {
        return null;
      }
      // return '$'+this.product.variants[0].price / 100;
      return Alpine.store('currency').formatMoney(this.product.variants[0].price / 100);
    },
    memberDiscountPercentage(variant = null) {
      // Get member discount percentage
      if (this.product && this.product.member_price) {

        const memberPrice = Alpine.store('currency').convertLocal(this.product.member_price);

        const selectedVariant = variant || this.product.variants[0];
        const selectedProductPrice = selectedVariant.price / 100;
        
        return (100 - (memberPrice / selectedProductPrice) * 100);
      }

      return 0;
    },
    calculateMemberDiscountedPrice(variant = null) {

      if (this.product && !this.product.product_type.toLowerCase().includes('clearance') && this.product.member_price) {
        const memberPrice = Alpine.store('currency').convertLocal(this.product.member_price);

        if ((this.product.variants[0].price / 100) > memberPrice) {
          return memberPrice;
        }
      }

      return null;
    },
    decimalPrice(price) {
      if (parseInt(price) == price) {
        return price+'.00';
      }

      return price;
    },
    async onFormSubmitHandler(atcRedirect, qty = 1) {
      console.log('onSubmitHandler...')

      if (Alpine.store('cart').isCartInProgress) {
        console.log('Cart is in progress');
        return;
      }

      if (Alpine.store('sale').refreshOnATC) {
        Alpine.store('cart').isSideCartOpen = true;
        Alpine.store('cart').isCartInProgress = true;
        
        // Refresh cart items to get latest cart details to avoid multi tab issue
        await Alpine.store('cart').loadItems();
      }

      const productForm = document.querySelector('product-form');
      console.log(productForm);
      // console.log(productForm.submitButton);
      // console.log(productForm.form);

      // if (productForm.submitButton.getAttribute('aria-disabled') === 'true') return;
      // const selectedVariantId = productForm.form.getElementsByClassName('product-variant-id')[0].value;
      const selectedFormVariantId = productForm.getElementsByClassName('product-variant-id')[0].value;

      // Get selectedVariant from x-data productTile
      const selectedVariantId = this.selectedVariant.id ? this.selectedVariant.id : selectedFormVariantId;

      const { cartItems, hasBundleItem, cartBundleItems, removeMultipleItems, hasAbsoluteFreeProduct } = Alpine.store('cart');

      const {
        settings: bundleSettings,
        isCompleted: isBundleCompleted,
        allIncludedBundleComponents,
        bundleKeyProducts,
        manualActiveIndex
      } = Alpine.store('customBundle');

      let itemProperties = {};
      let bundleItem = null
      // itemProperties.__member_discount_percentage = this.memberDiscount.percentage;
      itemProperties.__member_discount_price = this.memberDiscount.price;

      if (Alpine.store('edd')) {

        // See alpine-data.js for the equivalent gate. Skip writing the EDD
        // property when shouldHide is true (POD product, hide-EDD tag/vendor,
        // or any cart-level trigger). This keeps the line item clean and
        // prevents an out-of-date EDD from reappearing if the hide reason
        // resolves later.
        const { eddDateTextCart, daysInTransit, shouldHide, eddSettings } = Alpine.store('edd');
        if (eddDateTextCart && daysInTransit && !shouldHide) {
          itemProperties.__estimated_delivery_date = eddDateTextCart;
        }
        
        const { hideEddProductTags, hideEddVendors, hideEddOnPodProducts } = eddSettings;

        if (this.product.tags && Array.isArray(this.product.tags)) {
          if (hideEddProductTags.some((t) => t && this.product.tags.includes(t))) {
            itemProperties.__is_hide_edd = true;
          }
        }

        if (this.product.vendor && hideEddVendors.includes(this.product.vendor)) {
          itemProperties.__is_hide_edd = true;
        }

        const POD_REGEX = /POD:? /i;
        const isPodType = (typeStr) => POD_REGEX.test(typeStr || '');

        if (hideEddOnPodProducts && isPodType(this.product.product_type)) {
          itemProperties.__is_hide_edd = true;
        }
      }

      if (this.isBuyMoreActive) {
        itemProperties.__buy_more_bundle_item = { 
          buyMoreDiscounts: this.buyMoreDiscounts,
          saleName: 'Buy More Save More'
        };

        // Don't apply member price for "Buy More Save More" bundle
        delete itemProperties.__member_discount_price;
      }

      // const { saleDetails, hasOffer1FreeEnabled } = Alpine.store('sale');

      let addOnProduct = null;
      const addOnProductId = document.querySelector('#addon_checkbox_order_bump_product_id');
      const addOnProductInput = document.querySelector('#addon_checkbox_order_bump_input');
      if (addOnProductId && addOnProductInput && addOnProductInput.checked) {
        addOnProduct = {
          id: addOnProductId.value,
          quantity: 1,
          properties: { __is_add_on_product: true },
        }
      }

      let bbKit = null;
      let membershipProduct = null;

      if (this.selectedMembershipPlan == 'biblebox' && this.bbProductVariantId) {
        bbKit = {
          id: this.bbProductVariantId,
          quantity: 1,
          properties: { _bb_upgrade_kit: true, '_bb_offer_type--free_kit': true },
        }

        itemProperties._bb_upgrade_shirt = true;

        if (window.location.hostname.includes('.loveinfaith.life')) {
          bbKit.selling_plan = this.bbSellingPlanId;
        } 
      } else if (this.selectedMembershipPlan == 'lif-membership' && this.membershipProductVariantId) {
        membershipProduct = {
          id: this.membershipProductVariantId,
          quantity: 1,
          properties: { __is_member_product: true },
        }

        if (window.location.hostname.includes('.loveinfaith.life')) {
          membershipProduct.selling_plan = this.membershipProductSellingPlanId;
        }
      }

      const { saleName, saleKey, componentIndex } = this.customBundle;

      if (bundleSettings && saleKey && bundleSettings[saleKey] && bundleSettings[saleKey].isActive) {

        if (!isBundleCompleted[saleKey]) {

          const bundleItemIndex = componentIndex ? componentIndex : 0;
          
          const customBundleSaleProperties = {
            __winter_bundle_sale: { componentIndex: bundleItemIndex, productType: "", saleName, saleKey },
            _offer_limit_one_key: `custom-bundle-${saleKey}-${bundleItemIndex}` // This void to add same bundle index multiple times by checkout ext.
          }

          // Check if bundle item is added
          // if (!Alpine.store('cart').hasBundleItem) {
          if (!bundleKeyProducts[saleKey]) {
            bundleItem = {
              id: bundleSettings[saleKey].bundleProduct.variants[0].id,
              quantity: 1,
              properties: { __is_winter_product: true, saleKey },
            }
          }

          // Check if free product in cart
          if (hasAbsoluteFreeProduct) {
            
            const absoluteFreeProduct = cartItems.find((item) => item.properties.attributes && item.properties.attributes._is_absolute_free_product);

            // Delete Free Product
            if (absoluteFreeProduct) {
              await removeMultipleItems([absoluteFreeProduct.key]);
            }
          }

          itemProperties = { ...itemProperties, ...customBundleSaleProperties };
          
          // Allow to auto select filter after adding bundle item
          if (manualActiveIndex !== null) {
            Alpine.store('customBundle').manualActiveIndex = null;
          }

        } else if (this.applicableSale == LifSale.CUSTOM_BUNDLE) {
          const customBundleSaleProperties = {
            __winter_bundle_sale_fixed_price: { 
              type: 'FIXED', 
              price: parseFloat(this.customBundle.salePriceValue) * 100,
              saleName: this.customBundle.saleName 
            }
          }

          itemProperties = { ...itemProperties, ...customBundleSaleProperties };
        }
      } else if (this.applicableSale == LifSale.DYNAMIC_SALE) {
        const { saleTag, saleName, matchedProductTag, salePriceValue } = this.dynamicSale;
        const dynamicSaleProperty = {
          __dynamic_sale_tag: saleTag,
          __dynamic_sale_name: saleName,
          __tags: [matchedProductTag],
        }

        console.log(`salePriceValue: ${salePriceValue}`);
        console.log(`memberDiscountedPrice: ${this.memberDiscount.price}`);

        if (!Alpine.store('cart').shouldApplyMembershipDiscount || !this.memberDiscount.price || parseFloat(salePriceValue) < parseFloat(this.memberDiscount.price)) {
          // delete itemProperties.__member_discount_percentage;
          itemProperties = { ...itemProperties, ...dynamicSaleProperty };
        } else {
          console.log('Member discount should apply.');
        }
      } else if (this.applicableSale == LifSale.INCREMENTAL_SALE) {

        const { saleName, salePriceValue, offerCode } = this.incrementalSale;
        const variantPrice = this.product.variants[0].price / 100;
        if (variantPrice > this.incrementalSale.salePriceValue) {

          const lineItemIndex = offerCode == 'v2' ? Alpine.store('incrementalSaleV2').activeIndex : Alpine.store('incrementalSale').bundleItems.length;

          // Avoid duplicate offer to add
          if (Alpine.store('cart').isCartInProgress) {
            console.log('Sorry, Cart is still adding offer to cart. So please wait to finish!');
            return;
          }

          // Avoid duplicate offer to add
          if (Alpine.store('incrementalSale').bundleItemsByIndex[lineItemIndex]) {
            console.log('This offer item is already in your cart!');
            return;
          }

          itemProperties.__incremental_sale = {
            type: Alpine.store('incrementalSale').isCompleted || offerCode == 'v2' ? 'FIXED' : 'SALE',
            price: salePriceValue * 100,
            offerCode: offerCode,
            lineItemIndex,
            saleName
          }

          Alpine.store('cart').isCartInProgress = true;
        }
      }

      if (this.applicableSale == LifSale.OFFER_1_FREE && !this.cartHasFreeShirt) {
        itemProperties._is_free_shirt = true;
        itemProperties._applied_offer_type = 'Offer 1 Free';
        itemProperties._free_theshold = window.__LIF__.free_product_threshold;
      } else if (this.applicableSale == LifSale.OFFER_FIXED_PRICE && !this.cartHasFixedPriceShirt) {
        itemProperties.__fixed_price_offer = true;
        itemProperties._applied_offer_type = '$5 Sweatshirt';
        itemProperties._free_theshold = window.__LIF__.offer_fixed_price_settings.price_threshold;
      }

      if (Alpine.store('blackFridaySale').isActive) {
        if (this.applicableSale == LifSale.BLACK_FRIDAY && Alpine.store('blackFridaySale').activeOffer) {
          
          if (Alpine.store('cart').isCartInProgress) {
            console.log('Sorry, Cart is still adding offer to cart. So please wait to finish!');
            return;
          }

           // Avoid duplicate offer to add
           if (Alpine.store('blackFridaySale').offerItemsByIndex[this.blackFriday.offerIndex]) {
            console.log('This offer item is already in your cart!');
            return;
          }

          itemProperties.__black_friday_sale = { 
            isOfferProduct: true, 
            index: this.blackFriday.offerIndex 
          };

          // Detect this to delete when offer switched
          itemProperties.__black_friday_sale_discounted_item = true,

          // Using '__winter_bundle_sale_fixed_price' to make this work as fixed price in Checkout Extensiblity App without modifying code
          itemProperties.__winter_bundle_sale_fixed_price = { 
            type: 'FIXED', 
            price: parseFloat(this.blackFriday.salePriceValue) * 100,
            saleName: this.blackFriday.saleName
          }

          Alpine.store('cart').isCartInProgress = true;
        } else {
          if (Alpine.store('blackFridaySale').isAllowedBundleProduct(this.product)) {
            itemProperties.__black_friday_sale = { isBundleProduct: true }
          }
        }
      }

      const productVariant = this.product.variants.find((v) => v.id == selectedVariantId);
      if (productVariant && productVariant.price == 0) {
        itemProperties._is_absolute_free_product = true;
        itemProperties._free_theshold = window.__LIF__.free_product_threshold;

        // Check if bundle product in cart
        if (hasBundleItem || cartBundleItems.length > 0) {

          const bundleItemKeys = cartBundleItems.map((i) => i.key);
          bundleItemKeys.push(hasBundleItem.key);

          // Delete bundle items
          await removeMultipleItems(bundleItemKeys);
        }
      }

      if (this.product.product_type.toLowerCase().startsWith('free:')) {
        itemProperties._free_theshold = window.__LIF__.free_product_threshold;
      }

      // formData.properties = { attributes: itemProperties };

      if (this.isProductDODLimt1) {
        itemProperties = { ...itemProperties, __has_dod_limit_1 : true };
        const { removeItem, dodLimit1Product } = Alpine.store('cart');

        // Check if dod limit 1 product already exist
        if (dodLimit1Product) {
          await removeItem(dodLimit1Product.key, false);
        }
      }

      if (this.product.is_oversold_product) {
        itemProperties.__is_oversold_product = true;
      }

      console.log('itemProperties');
      console.log(itemProperties);
      
      const item = {
        id: selectedVariantId,
        quantity: qty,
        properties: itemProperties,
      }

      if (this.product.selling_plan_id) {
        item.selling_plan = this.product.selling_plan_id;
      }

      if (atcRedirect) {
        if (atcRedirect[0] == '#') {
          
          Alpine.store('freeProductTemplate').atcInitiated = true;

          setTimeout(() => {
            const element = document.querySelector(atcRedirect);
            console.log(element);

            if (element) {
              const headerOffset = 80;
              const elementPosition = element.getBoundingClientRect().top;
              const offsetPosition = elementPosition + window.scrollY - headerOffset;

              window.scrollTo({ top: offsetPosition, behavior: "smooth" });
            } else {
              console.log('No element to scroll.');
            }
          }, 500); // Let's Load visibility
        }
        Alpine.store('cart').addItems([item], () => {
          Alpine.store('cart').isCartInProgress = false;
          if (atcRedirect[0] != '#') {
            window.location.href = atcRedirect
          }
        }, false);
      } else {
        const items = [item];
        if (bundleItem) {
          items.push(bundleItem);
        }

        if (addOnProduct) {
          items.push(addOnProduct);
        }

        if (bbKit) {
          items.push(bbKit);
        }

        if (membershipProduct) {
          items.push(membershipProduct);
        }

        const shouldOpenSideCard = true; // !this.hasCompleteLookModal;
        // if (this.hasCompleteLookModal) {
        //   this.showCompleteLookModal = true;
        // }

        Alpine.store('cart').addItems(items, () => {
          Alpine.store('cart').isCartInProgress = false;
        }, true, shouldOpenSideCard);
      }
    }
  }));

  Alpine.data('freeProductThreshold', (thresholdValue) => ({
    addMoreShirtCollectionURL: '/test',
    hasMetThreshold: false,
    get cartItems() { return Alpine.store('cart').cartItems; },

    init() {
      console.log('thresholdValue: '+thresholdValue);
      
      this.$watch('cartItems', (cartItems) => {
        console.log('freeProductThreshold init: ');
        console.log(cartItems);

        let itemsSubtotal = 0;

        for (let i = 0; i < this.cartItems.length; i++) {
          const productType = this.cartItems[i].product_type.toLowerCase();
          // Exempt Clearance and Mystery products from being counted towards “Free:” product threshold
          if (
            !productType.includes('clearance') &&
            !productType.includes('mystery') &&
            !(productType === 'gift card') &&
            !productType.startsWith('Free:')
          ) {
            itemsSubtotal += this.cartItems[i].final_line_price;
          }
        }

        console.log(`Free Product Threshold - Items Sub Total: ${itemsSubtotal}`);
        this.hasMetThreshold = parseFloat(itemsSubtotal) / 100 >= parseFloat(thresholdValue);
      });
    },
  }));

});